import { stageColour } from '@/utils/ApprovalDashboard/stageColour';

// ─── F-04 helper component ─────────────────────────────────────────────────
// Coloured pill showing the current workflow stage name + optional progress
// indicator (e.g. "Stage 2 of 3").
export function StageBadge({ name, order, total }: { name: string; order?: number; total?: number }) {
  const colour = stageColour(name);
  const progress = order != null && total != null ? ` (${order}/${total})` : '';
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium border ${colour} whitespace-nowrap`}>
      {name}{progress}
    </span>
  );
}
